import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { gsap } from "gsap";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIPrevNext',
    props: /*#__PURE__*/ _mergeModels({
        as: { default: "div" },
        min: { default: Number.MIN_SAFE_INTEGER },
        max: { default: Number.MAX_SAFE_INTEGER },
        loop: { type: Boolean, default: false },
        theme: { default: "dark" }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["prev", "next"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const props = __props;
        const index = _useModel(__props, "modelValue", {
            set(value) {
                const modifier = gsap.utils[props.loop ? "wrap" : "clamp"];
                return modifier(props.min, props.max + +props.loop, value);
            }
        });
        const emit = __emit;
        function prev() {
            index.value--;
            emit("prev");
        }
        function next() {
            index.value++;
            emit("next");
        }
        return (_ctx, _cache) => {
            const _component_UIBtnArrow = _resolveComponent("UIBtnArrow");
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), { class: "UIPrevNext flex justify-between items-center pointer-events-none *:pointer-events-auto" }, {
                default: _withCtx(() => [
                    _createVNode(_component_UIBtnArrow, {
                        class: "flex-none disabled:pointer-events-none",
                        theme: _ctx.theme,
                        direction: "prev",
                        disabled: !_ctx.loop && index.value <= _ctx.min,
                        onClick: prev
                    }, null, 8, ["theme", "disabled"]),
                    _renderSlot(_ctx.$slots, "default"),
                    _createVNode(_component_UIBtnArrow, {
                        class: "flex-none disabled:pointer-events-none",
                        theme: _ctx.theme,
                        direction: "next",
                        disabled: !_ctx.loop && index.value >= _ctx.max,
                        onClick: next
                    }, null, 8, ["theme", "disabled"])
                ]),
                _: 3
            }));
        };
    }
});
